import DownloadRoundedIcon from "@mui/icons-material/DownloadRounded";
import { List, ListItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ProfileIcon } from "../../assets/images/profile.svg";
import { ReactComponent as WalletIcon } from "../../assets/images/wallet.svg";
import { NavLink } from "react-router-dom";
import httpClient from "../../common/httpCommon";
import { API_URLS } from "../../common/constants";
const SettingSidebar = ({ profileImgUrl, ...props }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { profileDetails } = useSelector((state) => state.profile);

  const downloadBlob = (blob, filename) => {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  const handleContractDownload = async (event) => {
    event.stopPropagation();
    try {
      // If legacy data stored a full URL, prefer it.
      const cd = profileDetails?.contractDocument || "";
      const looksLikeUrl = cd.startsWith("http://") || cd.startsWith("https://");
      if (looksLikeUrl) {
        const res = await fetch(cd);
        if (!res.ok) throw new Error(`Legacy contract URL fetch failed: ${res.status}`);
        const blob = await res.blob();
        downloadBlob(blob, "contract.pdf");
        return;
      }

      // Correct path: authenticated API endpoint serves the PDF.
      const token = localStorage.getItem("token") || sessionStorage.getItem("token");
      const res = await httpClient.client.get(API_URLS.GET_CONTRACT, {
        responseType: "blob",
        headers: token ? { Authorization: token } : undefined,
      });
      downloadBlob(res.data, "contract.pdf");
    } catch (error) {
      console.error("Error downloading contract:", error);
    }
  };

  return (
    <>
      <h3>Settings</h3>
      <List className="profile-menu">
        <ListItem>
          <NavLink
            to={"/profile"}
            className={({ isActive }) =>
              isActive ? "active menu_item1" : "menu_item1"
            }
          >
            <ProfileIcon />
            Profile
          </NavLink>
        </ListItem>
        <ListItem>
          <NavLink
            to={"/wallet"}
            className={({ isActive }) =>
              isActive ? "active menu_item2" : "menu_item2"
            }
          >
            <WalletIcon />
            Wallet
          </NavLink>
        </ListItem>
        {window.location.pathname.includes("profile") && (
          <ListItem className="profile-logout-btn">
            <NavLink onClick={(e) => handleContractDownload(e)}>
              <DownloadRoundedIcon />
              Download Contract
            </NavLink>
            {/* <Link onClick={() => handleLogout()}>
                    <LogoutRoundedIcon />
                    Log Out
                  </Link>
                    Sign Out
                  </Link> */}
          </ListItem>
        )}
      </List>
    </>
  );
};

export default SettingSidebar;
